<template>
  <div style="position: relative; z-index: 2">
    <div class="page__header">
      <div class="centered">
        <div class="initial-top">
          <div class="initial-top_cnt initial-top_cnt-left">
            <div class="initial-top_item">
              <div class="menu-toggler"
                   v-on:click="initialData.overlayMenu = !initialData.overlayMenu"
                   v-bind:class="{ 'menu-toggler--active' : initialData.overlayMenu }">
                <img v-if="!initialData.overlayMenu" class="menu-toggler__icon" src="@/assets/img/menu/burger_2_white.svg">
                <img v-if="initialData.overlayMenu" class="menu-toggler__icon" src="@/assets/img/menu/close_big.svg">
              </div>
            </div>
            <div class="initial-top_item"
                 v-if="!isActiveOverlayLogin && !initialData.overlayMenu">
                <span class="logo">
                  <img class="logo__image" src="@/assets/img/mft_logo__black.svg" />
                </span>
            </div>
            <div class="initial-top_item initial-top_item_mobile-enter">
              <div class="menu-toggler menu-toggler--active cl-1"
                   v-if="!isAuthorized"
                   v-on:click="isActiveOverlayLoginToggle()">
                <img class="menu-toggler__icon" src="@/assets/img/icon-login.svg">
              </div>
              <div class="menu-toggler cl-2"
                   v-if="isAuthorized && initialPage"
                   v-on:click="toggleInitialPage"
                   v-bind:class="{ 'menu-toggler--active' : initialData.overlayMenu }">
                <img class="menu-toggler__icon" src="@/assets/img/menu/profile_green.svg">
              </div>

              <router-link class="menu-toggler cl-2"
                           tag="div"
                           v-if="!isActiveOverlayLogin && isAuthorized && !initialPage"
                           :to="'/'">
                <img class="menu-toggler__icon" src="@/assets/img/menu/profile_w.svg">
              </router-link>
            </div>
          </div>
          <div class="initial-top_cnt initial-top_cnt-right">
            <div class="initial-top_item">
              <div class="callback-info"
                   v-bind:class="{ 'callback-info--white' : initialData.overlayMenu }">
                <div class="callback-info__title">Горячая линия</div>
                <div class="callback-info__phone"><a href="tel:88005553921"
                                                     v-bind:class="{ 'text-color-white' : initialData.overlayMenu }"
                                                     class="callback-info__number">8 (800) 555-3-921</a></div>
                <div class="callback-info__help-block"
                     v-bind:class="{ 'text-color-graylight3' : initialData.overlayMenu }">(звонок бесплатный)</div>
              </div>
            </div>
            <div class="initial-top_item">
              <button class="btn"
                      v-if="!isAuthorized"
                      v-on:click="toggleLoginPanel()"
                      v-bind:class="{
                        'btn-rounded' : !initialData.overlayMenu && !isActiveOverlayLogin,
                        'btn-rounded-white' : initialData.overlayMenu,
                        'btn-rounded-gray' : isActiveOverlayLogin && !initialData.overlayMenu
                      }">
                <span v-if="!isActiveOverlayLogin">Вход в систему</span>
                <span v-if="isActiveOverlayLogin">Вернуться на сайт</span>
              </button>
              <button class="btn"
                      v-if="!isActiveOverlayLogin && isAuthorized && initialPage"
                      v-on:click="toggleInitialPage()"
                      v-bind:class="{
                        'btn-rounded' : !initialData.overlayMenu && !isActiveOverlayLogin,
                        'btn-rounded-white' : initialData.overlayMenu,
                        'btn-rounded-gray' : isActiveOverlayLogin && !initialData.overlayMenu
                      }">
                <span>Личный кабинет</span>
              </button>
              <router-link class="btn"
                      v-if="!isActiveOverlayLogin && isAuthorized && !initialPage"
                      :to="'/'"
                      v-bind:class="{
                        'btn-rounded' : !initialData.overlayMenu && !isActiveOverlayLogin,
                        'btn-rounded-white' : initialData.overlayMenu,
                        'btn-rounded-gray' : isActiveOverlayLogin && !initialData.overlayMenu
                      }">
                <span>Личный кабинет</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page__auth-side-left" v-if="isActiveOverlayLogin">
      <AutorizeForms class="autorisation-panel--initial-page" ref="autorizeForms"></AutorizeForms>
    </div>

    <div class="page__auth-side-right"
         v-if="isActiveOverlayLogin"
         v-on:click="isActiveOverlayLoginToggle()">
      <div class="footer footer--auth-overlay "
           v-bind:class="{
             'text-color-white' : initialData.overlayMenu
           }">
        <div class="footer__copyright">
          <div class="footer__company">ООО «Мега – Ф Сервис»</div>
          <div class="footer__dates">© 2003–2021</div>
        </div>
        <div class="footer__description">
          Комплекс услуг по определению координат и маршрутов передвижения автомобиля,<br>
          обеспечению его безопасности, защите от угона и диагностике неисправностей двигателя. <br><br>
          Данные всех измерений являються оценочными.</div>
      </div>
    </div>

    <div class="page__content page__menu height-100" v-if="initialData.overlayMenu">
      <div class="centered height-100" style="background-color: #00888C">
        <div class="grid height-100">
          <div class="grid__cell-lg-20 offset-3 offset-lg-2 d-flex flex-column justify-content-between height-100">
            <div class="screen screen--overlay-menu d-flex flex-column flex-fill justify-content-center">
              <div class="menu">
                <div class="menu-list"
                     v-for="(menuList, menuListIndex) in menu"
                     v-bind:key="menuListIndex">
                  <div class="menu-title">
                    {{menuList.name}}
                  </div>
                  <div class="menu__item"
                       v-for="(menuItem, menuItemIndex) in menuList.list"
                       v-bind:key="menuItemIndex">
                    <span v-on:click="goToPage(menuItem.link)"
                          class="menu__link"
                          v-if="menuItem.type === 'link'">{{menuItem.name}}</span>
                    <span class="menu__link"
                          v-else
                          v-on:click="selectMenu( menuItem.index )">{{menuItem.name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer footer--menu-overlay">
              <div class="footer__copyright text-color-white">
                <div class="footer__dates">© 2003–2021 </div>
                <div class="footer__company">ООО «Мега – Ф Сервис»</div>
              </div>
              <div class="footer__description text-color-white">Комплекс услуг по определению координат и маршрутов передвижения автомобиля, обеспечению его безопасности, защите от угона и диагностике неисправностей двигателя.</div>
              <!--
              <div class="footer__lang">
                <div class="lang">
                  <div class="lang__item">
                    <span class="lang__toggler lang__toggler--active">Русский</span>
                  </div>
                  <div class="lang__item">
                    <span class="lang__toggler">English</span>
                  </div>
                </div>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutorizeForms from "../AutorizePanel/AutorizeForms"

export default {
  data() {
    return {
      menu: [
        {
          name : 'О системе',
          list : [
            {
              index : 0,
              name  : 'Мега-Ф телематика',
            },
            {
              index : 1,
              name  : 'Возможности Scher-Khan',
            },
            {
              index : 2,
              name  : 'Приложение Scher-Khan Auto'
            },
            {
              index : 3,
              name  : 'Mobicar Pro'
            }
          ]
        },
        {
          name : 'Пользователю',
          list : [
            {
              index : 4,
              name : 'Часто задаваемые вопросы'
            },
            {
              index : -1,
              name : 'Документация',
              type : 'link',
              link : '/docs'
            }
          ]
        },
        {
          name : 'О компании',
          list : [
            {
              index : 5,
              name  : 'История'
            },
            {
              index : 6,
              name  : 'Контакты'
            }
          ]
        }
      ],
    }
  },
  computed : {
    initialData : function (){
      return this.$store.state.initial
    },
    isAuthorized() {
      return this.$store.state.user.isAuthorized;
    },
    initialPage() {
      return this.$store.state.initialPage;
    },
    isActiveOverlayLogin(){
      return this.$store.state.panels.login.status
    },
    remind(){
      return this.$store.state.panels.login.remind
    }
  },
  methods : {
    isActiveOverlayLoginToggle(){
      this.$store.dispatch('toggleLoginPanel');
    },
    toggleLoginPanel(){
      this.$store.dispatch('toggleLoginPanel');
    },
    toggleInitialPage () {
      this.$store.dispatch('toggleInitialPage');
    },

    // Выбрали пункт меню
    selectMenu( index ){
      let gts = () => {
        this.initialData.overlayMenu = false;

        if( window.innerWidth > 1024 ){
          this.goToSlide( index );
        }else{
          let a = document.getElementsByClassName('mainSwiperInitial_item');
          window.scrollTo(0, a[index].offsetTop);
        }
      }

      if( !this.initialPage ){
        this.$store.state.initialPage = true;
        this.$router.push('/');
        setTimeout( ()=>{  gts();  }, 300);
      }else{
        gts();
      }
    },
    goToPage( link ){
      this.initialData.overlayMenu = false;
      this.$router.push( link );
    },
    goToSlide( index, speed ){
      this.$store.dispatch('changeInitialSlide', { index : index, speed : speed });
    },
  },
  components : {
    AutorizeForms
  }
}
</script>